
import React, { useMemo, useRef, useState, useCallback, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { toast } from 'react-toastify';
import "../../../../components/common/datatable/DataTable.css";
import { provideGlobalGridOptions } from 'ag-grid-community';
import ButtonComponent from "../../../../components/common/button/Button";
import "./CPSSupplierForecast.css"; // CSS shown below
import { Badge, Checkbox, IconButton, ListItemText, MenuItem, Popover, Select, CircularProgress, Box } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HistoryDataTable from "../HistoryDataTable";
import CopyPasteDateRows from "../CopyPasteDateRows";
import HistoryIcon from '@mui/icons-material/History';
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../../components/common/Loader";
import { getSupplierForecastSaveDataSlice } from "../../../../redux/actions/SupplierForecastSaveDataSlice";
import { getReasonCodeEndpoint, getSupplierForecastSaveDataEndpoint, hiddenColumnsEndpoint } from "../../../../common/endpoints";
import UploadExcelModal from "../UploadExcelModal";
import { postHideColumns } from "../../../../redux/actions/PostHideColumnsSlice";
import { getHideColumnsList } from "../../../../redux/actions/GetHideColumnsListSlice";
import "ag-grid-enterprise";
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { getReasonCodeSlice } from "../../../../redux/actions/getReasonCodeSlice";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { DateComparator } from "../../../../components/common/DateComparator";

provideGlobalGridOptions({
  theme: "legacy"
})

const CPSSupplierDataTable = ({ forecastTableData, isLoading, selectedStartingFrom, selectedViewBy, setSelectedViewBy, getSupplierForecastTable, keyFigureMapping, selectedViewByOptions, setSelectedViewByOptions }) => {
  const originalData = forecastTableData || [];
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState();
  const dispatch = useDispatch();
  const stateSelector = useSelector((state) => state);
  const saveTable = useSelector((state) => state.SupplierForecastSaveDataSlice);

  const editedRowsRef = useRef([]);

  const [disableFilterBtn, setDisableFilterBtn] = useState(true);
  const [disableSortBtn, setDisableSortBtn] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [reasonCodeData, setReasonCodeData] = useState([]);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [historySelectedRowData, setHistorySelectedRowData] = useState({});
  const [openCopyPasteModal, setOpenCopyPasteModal] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [copyPasteSelectedRowData, setCopyPasteSelectedRowData] = useState(false);
  const [badgeCount, setBadgeCount] = useState();
  const [selectedColumns, setSelectedColumns] = useState([]);
  // const [columnFilterDropdownOption, setColumnFilterDropdownOption] = useState([]);
  const [keyFigureToFieldMap, setKeyFigureToFieldMap] = useState(null);
  const [loadingCopyPaste, setLoadingCopyPaste] = useState(false);
  const pagination = true;
  const paginationPageSize = 500;
  const paginationPageSizeSelector = [10, 50, 100, 500, 1000];
  const [appliedHiddenColumns, setAppliedHiddenColumns] = useState([]);
  const userEmail = localStorage.getItem("userEmail");
  const loggedInUserRole = localStorage.getItem("userRole");
  const [isDownloading, setIsDownloading] = useState(false);
  const stateUpdate = useSelector((state) => state?.getforecastEmailSlice);


  const initialFilterAppliedRef = useRef(false);
  useEffect(() => {
    fetchHideColumnsData();
    getReasonCodeList()
  }, [])
  const getReasonCodeList = async () => {
    //     try {
    //       const response = await dispatch(
    //         getReasonCodeSlice({
    //           dynamicEndpoint: getReasonCodeEndpoint,
    //         })
    //       );

    //       if (response?.meta?.requestStatus === "fulfilled") {
    //         const list = response?.payload?.reasonCodeList;
    //         const formattedData = list.map((item) => ({
    //           reasonCode: item.reasonCode,
    //           description: item.description,
    //         }));
    // console.log("Formatted Reason Code Data:", formattedData);
    //         setReasonCodeData(formattedData);
    //       }
    //     } catch (error) {
    //       console.error("Reason Code API error:", error);
    //     }
  };

  const commentsCodeOptions = [
    "Incorrect Supplier Code Used",
    "Incorrect UOM",
    "Unable to Supply Item(s)",
    "Incorrect Description",
    "Plant maintenance",
    "Raw material shortage",
    "Short lead - time",
    "Not possible to supply, but can supply next month",
    "Out of specification / rejected batch",
    "Wait batch release/QC/IQD/JQC",
    "Other"
  ]

  const buildInitialFilterModel = useCallback(() => {
    const model = {};

    // Get the two dates from stateUpdate
    const latestCpsDate = stateUpdate?.latestCpsDate;
    const latestDpsDate = stateUpdate?.latestDpsDate;

    // Only include non-empty values
    const values = [latestCpsDate, latestDpsDate].filter(Boolean);

    if (values.length > 0) {
      // Apply filter only on lastCustUpdate column
      model.lastCustUpdate = {
        filterType: "multi",
        filterModels: [
          null,
          {
            filterType: "set",
            values: values, // one or both dates
          },
        ],
      };
    }

    return model;
  }, [stateUpdate]);



  const onGridReady = (params) => {
    setGridApi(params?.api);
    gridRef.current = params.api;
    setDisableSortBtn(false);
  }
  const onFilterChanged = (params) => {
    if (gridRef.current) {
      const filterModel = gridRef.current.getFilterModel();
      setDisableFilterBtn(Object.keys(filterModel).length === 0);
    }
    let hasDPS = false;

    for (let i = 0; i < params?.api?.getDisplayedRowCount(); i++) {
      const rowNode = params?.api?.getDisplayedRowAtIndex(i);

      if (rowNode?.data?.businessCategory === "DPS") {
        hasDPS = true;
        break;
      }
    }

    if (hasDPS) {
      setSelectedViewByOptions(prev =>
        prev?.includes("Weekly")
          ? ["Monthly", "Yearly"]
          : prev
      );

      setSelectedViewBy(prev => prev === "Weekly" ? "Monthly" : prev);
    } else {
      setSelectedViewByOptions(prev =>
        prev && !prev.includes("Weekly")
          ? ["Weekly", "Monthly", "Yearly"]
          : prev
      );
    }
  };
  const onSortChanged = (params) => {
    const colState = params.api.getColumnState();
    const isAnySortApplied = colState.some(col => col.sort);
    setDisableSortBtn(isAnySortApplied);
  };
  const gridOptions = {
    onFilterChanged,
    defaultColDef: {
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },

    }
  }

  const rowSpanFn = useCallback((params) => {
    if (!params.data) return 1;
    return params.data._rowIndexInGroup === 0 ? params.data._rowCountInGroup : 1;
  }, []);

  const handleOpenHistoryData = (data) => {
    setOpenHistoryModal(true);
    setHistorySelectedRowData(data)
  }
  const handleCloseShowHistoryModal = (a, b) => {
    setOpenHistoryModal(false);
    setHistorySelectedRowData({})
  }
  const handleOpenCopyPasteModal = (data) => {
    setOpenCopyPasteModal(true);
    setCopyPasteSelectedRowData(data)
  }
  const handleCloseCopyPasteModal = (a, b) => {
    if (loadingCopyPaste) return; // prevent closing while loading
    setOpenCopyPasteModal(false);
    setCopyPasteSelectedRowData({})

  }

  const handleCopyPasteConfirmation = () => {
    // Step 1: Immediately show loader and disable button
    setLoadingCopyPaste(true);

    // Step 2: Defer heavy processing to allow UI to repaint
    setTimeout(() => {
      const sourceRows = copyPasteSelectedRowData;
      if (!Array.isArray(sourceRows) || sourceRows.length === 0) {
        setLoadingCopyPaste(false); // No rows, hide loader
        return;
      }

      let nextSelectedRowsLocal = null;

      setRowData((prev) => {
        const updated = [...prev];

        sourceRows.forEach((sourceRow) => {
          const targetRowIndex = updated.findIndex(
            (r) =>
              r.tcccMaterialNumber === sourceRow.tcccMaterialNumber &&
              r.plantCode === sourceRow.plantCode &&
              r.supplierId.split(" | ")[0] === sourceRow.supplierId.split(" | ")[0] &&
              r.keyfigureName === "Supplier forecast qty confirmation"
          );

          if (targetRowIndex === -1) return;

          const targetRow = { ...updated[targetRowIndex] };
          const dateCols = Object.keys(sourceRow).filter((k) =>
            k.match(/(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/)
          );

          const updatedFields = { ...(targetRow.updatedFields || {}) };
          dateCols.forEach((col) => {
            updatedFields[col] = {
              old: targetRow[col],
              new: sourceRow[col],
            };
            targetRow[col] = sourceRow[col];
          });

          targetRow.total = dateCols.reduce((sum, col) => {
            const val = parseFloat(targetRow[col]);
            return sum + (isNaN(val) ? 0 : val);
          }, 0);

          targetRow.updatedFields = updatedFields;
          updated[targetRowIndex] = targetRow;

          // Update selected rows state
          setSelectedRows((prevSel) => {
            const prevArr = Array.isArray(prevSel) ? [...prevSel] : [];
            const existsIndex = prevArr.findIndex(
              (r) =>
                r.tcccMaterialNumber === targetRow.tcccMaterialNumber &&
                r.keyfigureName === targetRow.keyfigureName
            );

            if (existsIndex !== -1) {
              prevArr[existsIndex] = { ...targetRow };
              nextSelectedRowsLocal = prevArr;
            } else {
              nextSelectedRowsLocal = [...prevArr, { ...targetRow }];
            }

            return nextSelectedRowsLocal;
          });
        });

        // Re-select updated rows in the grid
        setTimeout(() => {
          try {
            const toKeep = nextSelectedRowsLocal || [];
            gridRef.current?.forEachNode((node) => {
              const shouldSelect = toKeep.some(
                (r) =>
                  r.tcccMaterialNumber === node.data.tcccMaterialNumber &&
                  r.keyfigureName === node.data.keyfigureName
              );
              if (shouldSelect) node.setSelected(true, false);
            });

            gridRef.current?.refreshCells();
          } catch (err) {
            console.warn("Copy-paste reselect error:", err);
          }

          // Hide loader and close modal
          setLoadingCopyPaste(false);
          setOpenCopyPasteModal(false);
          setCopyPasteSelectedRowData({});
        }, 50);

        return updated;
      });
    }, 50); // small delay to allow React to render loader
  };


  const calculateTotal = (row) => {
    // Skip total calculation for Comments row
    if (row.keyfigureName?.toLowerCase() === "comments") {
      return row.Total || 0;
    }
    // Include only date-formatted columns (ignore Comments or text columns)
    const dateCols = Object.keys(row).filter((k) =>
      k.match(/(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/) && k.toLowerCase() !== "comments"
    );
    const total = dateCols.reduce((sum, key) => {
      const val = parseFloat(row[key]);
      return isNaN(val) ? sum : sum + val;
    }, 0);
    return total;
  };

  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    if (!gridRef.current) return;
    if (!rowData?.length) return;
    if (!stateUpdate?.latestCpsDate && !stateUpdate?.latestDpsDate) return;
    if (initialFilterAppliedRef.current) return;

    const filterModel = buildInitialFilterModel();

    // Only apply if at least one date exists
    if (Object.keys(filterModel).length) {
      gridRef.current.setFilterModel(filterModel);
      gridRef.current.onFilterChanged();
      initialFilterAppliedRef.current = true;
    }
  }, [rowData, stateUpdate, buildInitialFilterModel]);

  useEffect(() => {
    if (originalData && originalData.length > 0 && keyFigureMapping) {
      const newRowData = transformOriginalForecastData(originalData, selectedViewBy, keyFigureMapping);
      setRowData(newRowData); // Set the processed data to state
    }
  }, [originalData, selectedViewBy, keyFigureMapping]);

  const dateColumns = rowData && rowData.length > 0
    ? Object.keys(rowData[0]).filter((k) =>
      k.match(/(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/)  // Matches "Dec 2024", "Jan 2025", etc.
    )
    : [];

  useEffect(() => {
    if (keyFigureMapping) {
      setKeyFigureToFieldMap(Object.fromEntries(
        Object.entries(keyFigureMapping).map(([key, value]) => [value, key])
      ))
    }
  }, [keyFigureMapping]);

  const formatTotal = (params) => {
    const row = params.data;
    let value = params.value;

    if (row?.keyfigureName?.toLowerCase() === "comments") {
      return "";
    }

    if (value == null || isNaN(value)) return "";

    const rounded = Math.round(value * 100) / 100;

    if (Number.isInteger(rounded)) {
      return rounded.toString();
    }

    return rounded.toString();
  };

  // Function to transform the data
  const transformOriginalForecastData = (forecastData, viewBy, keyFigureMap) => {
    const result = [];

    let timeline;
    if (viewBy === "Weekly") timeline = "weeklyTimeline";
    else if (viewBy === "Yearly") timeline = "yearlyTimeline";
    else timeline = "monthlyTimeline";

    forecastData.forEach((item, groupIndex) => {
      // Iterate through each key figure (k1, k2, etc.)
      Object.keys(keyFigureMap).forEach((kfKey, rowIndexInGroup) => {
        const keyFigureName = keyFigureMap[kfKey];
        const keyFigureData = {
          tcccMaterialNumber: item.materialId,
          description: item.materialDescription,
          materialGroupDescription: item.materialDescription,
          supplierPIN: item.supplierPin,
          supplierId: [item.supplierId, item.supplierName].filter(Boolean).join(" | "),
          packSize: item.packSize,
          incoterm: item.incoTerm,
          incoterm1: item.incoTerm1,
          country: [item.locationGeography, item.countryName].filter(Boolean).join(" | "),
          plantCode: item.plant,
          plantDescription: item.plantName,
          purchaseGroup: item.purchaseGroup,
          locationGeography: item.locationGeography,
          locationNationalRegion: item.locationNationalRegion,
          parentVendorName: item.parentVendorName,
          vendorCodeName: item.vendorCodeName,
          businessCategory: item.businessCategory,
          lastCustUpdate: item.lastCustomerUpdate,
          lastSuppUpdate: item.lastSupplierUpdate,
          unit: item.unit,
          plannerCode: item.plannerCode,
          status: item.status,
          materialGroup: item.materialGroup,
          keyfigureName: keyFigureName,
          _groupIndex: groupIndex,
          _rowIndexInGroup: rowIndexInGroup
        };

        if (item.businessCategory !== "DPS" || timeline !== "weeklyTimeline") {
          // Extract the timeline and add each date
          Object.keys(item[timeline]).forEach((date) => {
            // Set date value for the specific key figure
            keyFigureData[date] = item[timeline][date][kfKey] ?? null;
          });
        }

        keyFigureData.total = calculateTotal(keyFigureData);

        // Push the keyFigureData object to result (one for each key figure)
        result.push(keyFigureData);
      });
    });

    return result;
  };

  const cellRenderCheck = (params) => {
    if (params.data._rowIndexInGroup === 0 && disableFilterBtn) {
      return params.value;
    }
    else if (!disableFilterBtn) {
      return params.value;
    }
    else if (disableSortBtn) {
      return params.value;
    }
  }
  const languages = ["English", "Spanish", "French", "Portuguese", "(other)"];
  const columnDefs = [
    {
      headerName: "TCCC Material Number", field: "tcccMaterialNumber",
      pinned: 'left',
      lockPinned: true,
      lockPosition: true,
      width: 200,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Description", field: "description", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 150,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Plant Code", field: "plantCode", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 140,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Plant Description", field: "plantDescription", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 180,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Supplier PIN", field: "supplierPIN", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 150,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    // {
    //   headerName: "Location geography", field: "locationGeography", optionalField: true,
    //   rowSpan: rowSpanFn,
    //   cellRenderer: (params) => cellRenderCheck(params),
    // },
    // {
    //   headerName: "Location National Region", field: "locationNationalRegion", optionalField: true,
    //   rowSpan: rowSpanFn,
    //   cellRenderer: (params) => cellRenderCheck(params),
    // },
    {
      headerName: "Parent Vendor Name", field: "parentVendorName", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params),
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Vendor Code", field: "supplierId", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params),
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Business Category", field: "businessCategory", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 160,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Pack Size", field: "packSize", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 140,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Unit", field: "unit", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 130,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Incoterm", field: "incoterm", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 150,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Incoterm1", field: "incoterm1", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 150,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Region and Country", field: "country", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 180,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Last Cust Update", field: "lastCustUpdate", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 160,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
      comparator: DateComparator,
    },
    {
      headerName: "Last Supp Update", field: "lastSuppUpdate", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 160,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
      comparator: DateComparator,
    },
    {
      headerName: "Status", field: "status", optionalField: true,
      rowSpan: rowSpanFn,
      cellRenderer: (params) => cellRenderCheck(params), width: 150,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
    },
    {
      headerName: "Key Figures", field: "keyfigureName",
      pinned: 'left',
      lockPinned: true,
      lockPosition: true,
      width: 200,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
      cellRenderer: (response) => {
        return (
          <div style={{ display: 'flex' }}>
            <span>{response.value}</span>
            {response.value === "Forecast Pick Up" && <div style={{ display: 'flex', cursor: "pointer", marginLeft: 10, justifyContent: 'center', alignItems: 'center' }} onClick={() => handleOpenHistoryData(response.data)} ><HistoryIcon style={{ fontSize: 20 }} /> </div>}
          </div>
        )
      }
    },
    ...dateColumns.map((date) => ({
      headerName: date,
      field: date,
      width: 180,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
      editable: (params) =>
        (loggedInUserRole !== "App Admin" && selectedViewBy !== 'Yearly' && params.data.keyfigureName === "Supplier forecast qty confirmation") ||
        (loggedInUserRole !== "App Admin" && selectedViewBy !== 'Yearly' && params.data.keyfigureName === "Comments"),
      cellStyle: (params) => ({
        backgroundColor:
          (loggedInUserRole !== "App Admin" && selectedViewBy !== 'Yearly' && params.data.keyfigureName === "Supplier forecast qty confirmation") ||
            (loggedInUserRole !== "App Admin" && selectedViewBy !== 'Yearly' && params.data.keyfigureName === "Comments")
            ? "#fff9e6"
            : undefined,
      }),
      valueParser: (params) => {
        if (params.data.keyfigureName === "Comments") return params.newValue;
        const val = parseFloat(params.newValue);
        return isNaN(val) ? null : val;
      },

      cellEditorSelector: (params) => {
        if (params.data.keyfigureName === "Comments") {
          // If current value is "Others", open Text Editor when entering edit
          if (params.value === "Other") {
            return { component: "agTextCellEditor" };
          }
          return {
            component: "agRichSelectCellEditor",
            params: {
              values: commentsCodeOptions,
              cellHeight: 40
            }
          };
        }

        return { component: "agTextCellEditor" };
      },

    })),
    {
      headerName: "Total", field: "total",
      width: 150,
      wrapText: true,
      autoHeight: true,
      cellClass: "wrap-cell",
      filter: "agSetColumnFilter",
      valueFormatter: (params) => formatTotal(params),
      filterParams: {
        valueFormatter: (params) => formatTotal(params),
      },
    },
  ];

  // const [filteredColumnsData, setFilteredColumnsData] = useState(columnDefs);

  // Dropdown options for optional columns
  const columnFilterDropdownOption = useMemo(() => {
    if (!columnDefs?.length) return [];
    return columnDefs.filter((col) => col.optionalField === true);
  }, [columnDefs]);

  // Filtered columns for AG Grid
  const filteredColumnsData = useMemo(() => {
    if (!columnDefs?.length) return [];
    return columnDefs.filter(
      (col) => !col.optionalField || !appliedHiddenColumns.includes(col.headerName)
    );
  }, [columnDefs, appliedHiddenColumns]);

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: 'agTextColumnFilter',
            filterParams: {
              suppressMiniFilter: false,
            },
          },
          {
            filter: 'agSetColumnFilter',
            filterParams: {
              excelMode: 'windows',
              suppressMiniFilter: false,
              buttons: ['apply', 'reset'],
            },
          },
        ],
      },
    }),
    []
  );
  const selectionColumnDef = useMemo(() => ({
    pinned: 'left'
  }))

  const onCellValueChanged = useCallback((params) => {

    const { colDef, data, oldValue, newValue, api, node } = params;

    if (oldValue === newValue) return;

    const field = colDef.field;

    // store updated values
    data.updatedFields = {
      ...(data.updatedFields || {}),
      [field]: {
        old: oldValue,
        new: newValue,
      },
    };

    // recalculate total
    data.total = calculateTotal(data);

    // refresh cells
    api.refreshCells({
      rowNodes: [node],
      columns: [field, "total"],
      force: true
    });

    // auto select row
    if (!node.isSelected()) {
      node.setSelected(true);
    }

    // IMPORTANT:
    // update ref synchronously
    const existingIndex = editedRowsRef.current.findIndex(
      (r) =>
        r.tcccMaterialNumber === data.tcccMaterialNumber &&
        r.keyfigureName === data.keyfigureName
    );

    if (existingIndex !== -1) {
      editedRowsRef.current[existingIndex] = { ...data };
    } else {
      editedRowsRef.current.push({ ...data });
    }

    // optional UI state
    setSelectedRows([...editedRowsRef.current]);

  }, []);

  const onSelectionChanged = (params) => {
    const filteredSelectedRows = [];
    params?.api?.forEachNodeAfterFilter((node) => {
      if (node.isSelected()) {
        filteredSelectedRows.push(node.data);
      }
    });
    setSelectedRows(filteredSelectedRows);
  }
  const rowSelection = useMemo(() => {
    return {
      mode: 'multiRow',
      isRowSelectable: (rowNode) => rowNode?.data?.keyfigureName === "Supplier forecast qty confirmation" || rowNode?.data?.keyfigureName === "Comments",
    }
  })

  const onClickDownloadButton = async () => {
    try {
      setIsDownloading(true);
      const excelData = gridApi.getDataAsExcel({
        fileName: "ForecastData",
        sheetName: "ForecastData"
      });
      const fieldMap = {
        "Supplier PIN": "supplierPIN",
        "Vendor Code": "supplierId",
        "Material Group": "materialGroup",
        "Planner Code": "plannerCode",
        "Plant Code": "plantCode",
      };

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(new Blob([excelData]));
      const worksheet = workbook.worksheets[0];
      const rowData = [];
      gridApi.forEachNodeAfterFilterAndSort(node => rowData.push(node.data))

      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return; // skip header row
        const original = rowData[rowNumber - 2]; // Excel row 2 = rowData[0]
        if (!original) return;

        row.eachCell((cell, colNumber) => {
          let headerVal = worksheet.getRow(1).getCell(colNumber).value;
          if (typeof headerVal === "object" && headerVal.richText) {
            headerVal = headerVal.richText.map(rt => rt.text).join("");
          }
          const field = fieldMap[headerVal];
          if (field && original[field] != null) {
            cell.value = "\u200B" + original[field].toString();
            cell.numFmt = "@";
            cell.protection = { locked: true }; // optional
          }
        });
      });


      worksheet.views = [
        {
          state: "frozen",
          xSplit: 2,   // number of columns to freeze
          ySplit: 1,   // keep header row frozen (optional but recommended)
          topLeftCell: "C2",
          activeCell: "C2"
        }
      ];

      worksheet.views = [
        {
          state: "frozen",
          xSplit: 2,   // number of columns to freeze
          ySplit: 1,   // keep header row frozen (optional but recommended)
          topLeftCell: "C2",
          activeCell: "C2"
        }
      ];

      worksheet.getRow(1).eachCell(cell => {
        cell.protection = { locked: false };
      });
      worksheet.getRow(1).protection = { locked: false };
      worksheet.getRow(1).font = { bold: true };

      // ---------------- DROPDOWN LIST SHEET ----------------
      const listSheet = workbook.addWorksheet("CommentsList", { state: "hidden" });

      commentsCodeOptions.forEach((value, index) => {
        listSheet.getCell(`A${index + 1}`).value = value;
      });

      // ---------------- IDENTIFY COLUMNS ----------------
      let keyFigureColIndex;
      let totalColIndex = null;
      const dateColumnIndexes = [];

      worksheet.getRow(1).eachCell((cell, colNumber) => {
        const value = cell.value;

        if (value === "Key Figures") keyFigureColIndex = colNumber;
        if (value === "Total") totalColIndex = colNumber;

        if (typeof value === "string" && /\b\d{4}\b/.test(value)) {
          dateColumnIndexes.push(colNumber);
        }
      });

      const lastDataRow = worksheet.lastRow?.number || worksheet.rowCount || 1;

      // ---------------- LOCK LEFT SECTION ----------------
      for (let row = 1; row <= lastDataRow; row++) {
        for (let col = 1; col <= keyFigureColIndex; col++) {
          const cell = worksheet.getRow(row).getCell(col);

          cell.protection = { locked: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF2F2F2" }
          };
        }
      }

      // ---------------- LOCK DATE COLUMNS ----------------
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;

        dateColumnIndexes.forEach(colIndex => {
          const cell = row.getCell(colIndex);
          cell.protection = { locked: true };
          cell.fill = null;
        });
      });

      // ---------------- ENABLE FILTERS ----------------
      const lastCol = worksheet.columnCount;
      const lastColLetter = worksheet.getColumn(lastCol).letter;

      worksheet.autoFilter = {
        from: "A1",
        to: `${lastColLetter}1`
      };

      // ---------------- EDITABLE LOGIC ----------------
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return;

        const keyFigureValue = row.getCell(keyFigureColIndex).value;

        // Comments dropdown
        if (keyFigureValue === "Comments") {
          dateColumnIndexes.forEach(colIndex => {
            const cell = row.getCell(colIndex);

            cell.dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: ["CommentsList!$A$1:$A$10"]
            };

            cell.protection = { locked: false };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFFF9E6" }
            };
          });
        }

        const isEditableRow =
          keyFigureValue === "Supplier forecast qty confirmation" ||
          keyFigureValue === "Comments";

        if (isEditableRow) {
          dateColumnIndexes.forEach(colIndex => {
            const cell = row.getCell(colIndex);

            cell.protection = { locked: false };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFFF9E6" }
            };
          });
        }
      });

      // ---------------- TOTAL FORMULAS ----------------
      if (totalColIndex && dateColumnIndexes.length > 0) {
        const startColLetter = worksheet.getColumn(dateColumnIndexes[0]).letter;
        const endColLetter =
          worksheet.getColumn(dateColumnIndexes[dateColumnIndexes.length - 1]).letter;

        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return;

          const keyFigureValue = row.getCell(keyFigureColIndex).value;

          if (keyFigureValue === "Comments") {
            row.getCell(totalColIndex).value = "";
            row.getCell(totalColIndex).protection = { locked: true };
            return;
          }

          row.getCell(totalColIndex).value = {
            formula: `SUM(${startColLetter}${rowNumber}:${endColLetter}${rowNumber})`
          };

          row.getCell(totalColIndex).protection = { locked: true };
        });
      }
      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
      worksheet.eachRow({ includeEmpty: true }, (row) => {
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.border = borderStyle;
        });
      });
      // ---------------- PROTECT SHEET ----------------
      await worksheet.protect("", {
        selectLockedCells: true,
        selectUnlockedCells: true,
        formatCells: true,
        formatColumns: true,
        formatRows: true,
        insertRows: false,
        insertColumns: false,
        deleteRows: true,
        deleteColumns: true,
        sort: true,
        autoFilter: true
      });

      // ---------------- DOWNLOAD ----------------
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), "ForecastData.xlsx");

    } catch (error) {
      console.error("Excel download failed", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const getOverrideRequestBody = (rows = []) => {
    const userEmail = localStorage.getItem("userEmail");
    if (!rows || rows.length === 0) return null;

    const groupedRows = {};

    // Group selectedRows by supplier + material + plant + businessCategory
    rows.forEach((row) => {
      const key = `${row.supplierId}|${row.tcccMaterialNumber}|${row.plantCode}|${row.businessCategory}`;
      if (!groupedRows[key]) groupedRows[key] = [];
      groupedRows[key].push(row);
    });

    const forecastOverrideDetailsList = [];
    const commentsOverrideDetailsList = [];

    // Regex to match date formats: "05 Jan 2026", "Jan 2026", "2026"
    const dateKeyRegex = /(\d{1,2} [A-Za-z]{3} \d{4})|([A-Za-z]{3} \d{4})|(\d{4})/;

    Object.values(groupedRows).forEach((rows) => {
      const firstRow = rows[0];
      const timelineMapForecast = {};
      const timelineMapComments = {};

      rows.forEach((row) => {
        const isComment = row.keyfigureName?.toLowerCase() === "comments";

        // -----------------------------
        // FORECAST → SEND ALL DATES
        // -----------------------------
        if (!isComment) {
          Object.entries(row).forEach(([key, value]) => {
            if (dateKeyRegex.test(key) && typeof value === "number") {
              timelineMapForecast[key] = {
                forecastDate: key,
                supplierQuantity: Number(value),
              };
            }
          });

          // Override updatedFields if any
          Object.entries(row.updatedFields || {}).forEach(([date, change]) => {
            if (change?.new !== undefined && change.new !== "") {
              timelineMapForecast[date] = {
                forecastDate: date,
                supplierQuantity: Number(change.new),
              };
            }
          });
        }

        // -----------------------------
        // COMMENTS → ONLY UPDATED DATES
        // -----------------------------
        if (isComment) {
          Object.entries(row.updatedFields || {}).forEach(([date, change]) => {
            if (change?.commentCode || change?.commentText) {
              timelineMapComments[date] = {
                forecastDate: date,
                commentCode: change.commentCode ?? null,
                commentText: change.commentText ?? null,
              };
            }
          });
        }
      });

      if (Object.keys(timelineMapForecast).length > 0) {
        forecastOverrideDetailsList.push({
          supplier: firstRow.supplierId?.split(" | ")[0] || "",
          material: firstRow.tcccMaterialNumber,
          plant: firstRow.plantCode,
          businessCategory: firstRow.businessCategory,
          timelineOverrideList: Object.values(timelineMapForecast),
        });
      }

      if (Object.keys(timelineMapComments).length > 0) {
        commentsOverrideDetailsList.push({
          supplier: firstRow.supplierId?.split(" | ")[0] || "",
          material: firstRow.tcccMaterialNumber,
          plant: firstRow.plantCode,
          businessCategory: firstRow.businessCategory,
          timelineOverrideList: Object.values(timelineMapComments),
        });
      }
    });

    return {
      userEmail,
      forecastOverrideDetailsList,
      commentsOverrideDetailsList,
    };
  };

  const getSupplierForecastSaveDataTable = async (rows) => {
    const requestBody = getOverrideRequestBody(rows);

    try {
      const responseSupplierForecastSaveData = await dispatch(getSupplierForecastSaveDataSlice({
        dynamicEndpoint: `${getSupplierForecastSaveDataEndpoint}`,
        data: requestBody
      }));

      if (responseSupplierForecastSaveData?.meta?.requestStatus === 'fulfilled') {
        toast.success(responseSupplierForecastSaveData?.payload, {
          autoClose: 2000,
        });

      }
      else {
        toast.error(responseSupplierForecastSaveData?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
    }
    finally {
      setSelectedRows([]);
      gridApi?.deselectAll();
      setDisableFilterBtn(true);
      getSupplierForecastTable(selectedViewBy, selectedStartingFrom);
    }
  }
  const onSuccessFileUpload = () => {
    setSelectedRows([]);
    gridRef.current?.deselectAll();
    setDisableFilterBtn(true);
    getSupplierForecastTable(selectedViewBy, selectedStartingFrom);
  }
  
  const onClickSaveChanges = () => {
    // commit active editing cell
  gridRef.current?.stopEditing();

  setTimeout(() => {

    // get only checked + edited rows
    const checkedEditedRows = [];

    gridRef.current?.forEachNode((node) => {

      // only checked rows
      if (node.isSelected()) {

        // find edited row
        const editedRow = editedRowsRef.current.find(
          (r) =>
            r.tcccMaterialNumber === node.data.tcccMaterialNumber &&
            r.keyfigureName === node.data.keyfigureName
        );

        // push only edited rows
        if (editedRow) {
          checkedEditedRows.push(editedRow);
        }
      }

    });

    // send only checked edited rows
    getSupplierForecastSaveDataTable(checkedEditedRows);

  }, 0);
  }

  const CHUNK_SIZE = 200; // adjust based on performance

  const processInChunks = async (nodes, callback) => {
    for (let i = 0; i < nodes.length; i += CHUNK_SIZE) {
      const chunk = nodes.slice(i, i + CHUNK_SIZE);
      chunk.forEach(callback);
      await new Promise((resolve) => setTimeout(resolve, 0)); // yield to UI
    }
  };

  const onClickCopyForecast = async () => {
    if (!gridRef.current) return;
    const gridApi = gridRef.current;

    //  STEP 1: open confirmation popup immediately
    setOpenCopyPasteModal(true);

    // STEP 2: yield so popup renders
    await new Promise((resolve) => setTimeout(resolve, 0));

    const selectedNodes = gridApi.getSelectedNodes();

    // ======================
    // CASE 1: Selected rows
    // ======================
    if (selectedNodes.length > 0) {
      const filteredRows = [];

      await processInChunks(selectedNodes, (node) => {
        const nodeData = node.data;
        if (!nodeData) return;

        gridApi.forEachNodeAfterFilter((forecastNode) => {
          const forecastData = forecastNode.data;
          if (!forecastData) return;

          if (
            forecastData.keyfigureName === "Forecast Pick Up" &&
            forecastData.tcccMaterialNumber === nodeData.tcccMaterialNumber &&
            forecastData.plantCode === nodeData.plantCode &&
            forecastData.supplierId === nodeData.supplierId
          ) {
            forecastNode.setSelected(true, false);
            filteredRows.push(forecastData);
          }
        });
      });

      handleOpenCopyPasteModal(filteredRows);
      return;
    }

    // ======================
    // CASE 2: No selection (large data)
    // ======================
    const allForecastRows = [];
    const supplierMap = new Map();

    const rowCount = gridApi.getDisplayedRowCount();

    for (let start = 0; start < rowCount; start += CHUNK_SIZE) {
      const end = Math.min(start + CHUNK_SIZE, rowCount);

      for (let i = start; i < end; i++) {
        const rowNode = gridApi.getDisplayedRowAtIndex(i);
        const data = rowNode?.data;
        if (!data) continue;

        if (data.keyfigureName === "Forecast Pick Up") {
          allForecastRows.push(data);
        } else if (data.keyfigureName === "Supplier forecast qty confirmation") {
          const key = `${data.tcccMaterialNumber}|${data.plant}|${data.supplierId}`;
          if (!supplierMap?.has(key)) supplierMap?.set(key, []);
          supplierMap?.get(key).push(rowNode);
        }
      }

      // keep UI responsive
      await new Promise((resolve) => setTimeout(resolve, 0));
    }

    const forecastRows = [];

    await processInChunks(allForecastRows, (forecastData) => {
      const key = `${forecastData.tcccMaterialNumber}|${forecastData.plant}|${forecastData.supplierId}`;
      if (supplierMap?.has(key)) {
        forecastRows.push(forecastData);
      }
    });

    handleOpenCopyPasteModal(forecastRows);
  };

  const onClickUploadButton = () => {
    setOpenUploadModal(true);
  }
  const onClickCloseUploadModal = () => {
    setOpenUploadModal(false);
  }

  const clearAllFilters = () => {
    if (gridRef.current) {
      gridRef.current.setFilterModel(null);
      setDisableFilterBtn(true);
    }
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClickHide = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseHide = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleHideColumnChange = (event) => {
    setSelectedColumns(event.target.value);
  };
  const renderDropdownValue = (selected) => {
    if (selected?.length === 0) return "Select Columns";
    if (selected?.length === 1) return columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;
    const firstColumnName = columnFilterDropdownOption.find(col => col?.headerName === selected?.[0])?.headerName;
    return `${firstColumnName}, +${selected?.length - 1}`;
  };

  const fetchHideColumnsData = async () => {
    try {
      const responseHideSupplierColumnData = await dispatch(getHideColumnsList({
        dynamicEndpoint: hiddenColumnsEndpoint,
        params: {
          userEmail: userEmail,
          screenType: loggedInUserRole === "Supplier Admin" ? "ADMIN_FORECAST" : loggedInUserRole === "Supplier Planner" ? "SUPPLIER_FORECAST" : loggedInUserRole === "Global Planner" ? "BUYER_FORECAST" : loggedInUserRole === "Regional Planner"
            ? "REGIONAL_PLANNER" : loggedInUserRole === "Global Viewer" ? "GLOBAL_VIEWER" :
              loggedInUserRole === "Regional Viewer"
                ? "REGIONAL_VIEWER"
                : "APP_ADMIN_FORECAST"
        }
      }));
      if (responseHideSupplierColumnData?.meta?.requestStatus === 'fulfilled') {
        setSelectedColumns(responseHideSupplierColumnData.payload);     // UI
        setAppliedHiddenColumns(responseHideSupplierColumnData.payload); // GRID
        setBadgeCount(responseHideSupplierColumnData.payload.length);

      } else {
        console.error('Failed to fetch data:', responseHideSupplierColumnData?.error);
        toast.error(responseHideSupplierColumnData?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }

  const handleSave = async () => {
    const responseBody = {
      "userEmail": userEmail,
      "hiddenColumns": selectedColumns,
      screenType: loggedInUserRole === "Supplier Admin" ? "ADMIN_FORECAST" : loggedInUserRole === "Supplier Planner" ? "SUPPLIER_FORECAST" : loggedInUserRole === "Global Planner" ? "BUYER_FORECAST" : loggedInUserRole === "Regional Planner"
        ? "REGIONAL_PLANNER" : loggedInUserRole === "Global Viewer" ? "GLOBAL_VIEWER" :
          loggedInUserRole === "Regional Viewer"
            ? "REGIONAL_VIEWER"
            : "APP_ADMIN_FORECAST"
    }

    try {
      const responsePostHideColumns = await dispatch(postHideColumns({
        dynamicEndpoint: `${hiddenColumnsEndpoint}`,
        data: responseBody
      }));
      if (responsePostHideColumns?.meta?.requestStatus === 'fulfilled') {
        setAppliedHiddenColumns(selectedColumns);
        setBadgeCount(selectedColumns.length);
        handleCloseHide();
      } else {
        console.error('Failed to fetch data:', responsePostHideColumns?.error);
        toast.error(responsePostHideColumns?.payload?.errorMessage, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
      toast.error(error, {
        autoClose: 2000,
      });
    }
  }
  return (
    <div>
      <div style={{ display: 'flex', marginTop: 10 }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: 10 }}>
            <IconButton onClick={handleClickHide}>
              <Badge badgeContent={badgeCount > 0 ? badgeCount : null} sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.6rem", // Smaller font size
                  height: "16px", // Adjust badge height
                  minWidth: "16px", // Adjust badge width
                  padding: "4px", // Adjust padding
                  background: '#000',
                  color: '#fff'
                },
              }}
              >
                <MoreVertIcon />
              </Badge>
            </IconButton>
            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleCloseHide}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              className="hidePopover"
              sx={{
                marginTop: 1,
                marginLeft: 0,
              }}
            >
              <div style={{ padding: 10, width: 150 }}>
                <p style={{ marginBottom: 10, marginTop: 5 }}>Hide Columns</p>
                <Select
                  multiple
                  value={selectedColumns}
                  onChange={handleHideColumnChange}
                  renderValue={renderDropdownValue}
                  displayEmpty
                  sx={{ backgroundColor: "#fff", border: '1px solid #000', width: '100%', height: 35, marginBottom: 5 }}
                >
                  <MenuItem disabled value="">
                    <em>Select Columns</em>
                  </MenuItem>
                  {columnFilterDropdownOption?.map(col => (
                    <MenuItem key={col.headerName} value={col.headerName}>
                      <Checkbox
                        checked={!selectedColumns?.includes(col.headerName)}
                      />
                      <ListItemText primary={col.headerName} />
                    </MenuItem>
                  ))}
                </Select>
                {stateSelector?.PostHideColumnsSlice?.loading ?
                  <Box style={{ textAlign: 'center' }}>
                    <CircularProgress color="inherit" style={{ width: '20px', height: '20px', textAlign: 'center' }} />
                  </Box>
                  :
                  <ButtonComponent type="secondary" label="Save" onClick={handleSave} />
                }
              </div>
            </Popover>
          </div>
          <ButtonComponent
            maxWidth="150px"
            label="Clear Filters"
            bgColor="black"
            color="white"
            disabled={disableFilterBtn}
            onClick={clearAllFilters}
          />

          <ButtonComponent
            type="secondary"
            maxWidth="130px"
            label="Save"
            height="30px"
            disabled={selectedRows?.length === 0 || selectedViewBy === 'Yearly' || saveTable.loading}
            onClick={onClickSaveChanges}
          />
          <ButtonComponent
            type="secondary"
            maxWidth="130px"
            label="Copy Forecast"
            height="30px"
            disabled={originalData.length == 0 || saveTable.loading}
            onClick={onClickCopyForecast}
          />
          <FileDownloadIcon
            disabled={(!isDownloading && rowData?.length !== 0) ? false : true}
            style={{
              cursor: 'pointer',
              fontSize: 24,
              border: "1px solid black",
              borderRadius: "4px",
              padding: "2px",
              opacity: (!isDownloading && rowData?.length !== 0) ? 1 : 0.4,
              pointerEvents: (!isDownloading && rowData?.length !== 0) ? "auto" : "none"
            }}
            onClick={!isDownloading && rowData?.length !== 0 ? onClickDownloadButton : undefined}
            titleAccess={"Download"}
          />
          <FileUploadIcon
            onClick={onClickUploadButton}
            style={{
              cursor: 'pointer', fontSize: 24,
              border: "1px solid black",
              borderRadius: "4px",
              padding: "2px"
            }}
            titleAccess={"Upload"}
          />
        </div>
      </div>
      <div style={{ margin: '10px 0px' }}>
        {isLoading || saveTable.loading ? <Loader /> :
          originalData.length > 0 ?
            <div className="ag-theme-quartz" style={{ height: 400, width: '100%' }}>
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                // columnDefs={columnDefs}
                columnDefs={filteredColumnsData}
                onGridReady={onGridReady}
                gridOptions={gridOptions}
                onSortChanged={onSortChanged}
                selectionColumnDef={selectionColumnDef}
                defaultColDef={defaultColDef}
                onCellValueChanged={onCellValueChanged}
                onCellEditingStarted={(params) => {
                  // auto check checkbox
                  if (!params.node.isSelected()) {
                    params.node.setSelected(true);
                  }

                  // update selectedRows immediately
                  setSelectedRows((prev) => {
                    const exists = prev.find(
                      (r) =>
                        r.tcccMaterialNumber === params.data.tcccMaterialNumber &&
                        r.keyfigureName === params.data.keyfigureName
                    );

                    if (exists) return prev;

                    return [...prev, { ...params.data }];
                  });
                }}
                pagination={pagination}
                paginationPageSize={paginationPageSize}
                paginationPageSizeSelector={paginationPageSizeSelector}
                rowSelection={rowSelection}
                onSelectionChanged={onSelectionChanged}
              />
              <HistoryDataTable openHistoryModal={openHistoryModal} historySelectedRowData={historySelectedRowData} handleCloseShowHistoryModal={handleCloseShowHistoryModal} selectedStartingFrom={selectedStartingFrom} selectedViewBy={selectedViewBy} />
              <CopyPasteDateRows openCopyPasteModal={openCopyPasteModal} copyPasteSelectedRowData={copyPasteSelectedRowData} handleCloseCopyPasteModal={handleCloseCopyPasteModal} handleCopyPasteConfirmation={handleCopyPasteConfirmation} loadingCopyPaste={loadingCopyPaste} />
            </div>
            :
            <div style={{ margin: '10px 0px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
              {originalData?.length === 0 ? <span>No Data Available</span> : <></>}
            </div>
        }
      </div>
      <UploadExcelModal openUploadModal={openUploadModal} handleCloseUploadModal={onClickCloseUploadModal} onSuccessFileUpload={onSuccessFileUpload} />
    </div>
  );
};
export default CPSSupplierDataTable;
